module.exports = "/_next/static/images/6ba71ae84f3f29a3d66d5d475733ed44-card-new.svg.webp";